export default "__VITE_ASSET__DGNXnOxx__"